module.exports = __webpack_public_path__ + "static/media/background_mobile1.d18eee88.png";